import { Component } from '@angular/core';

@Component({
  selector: 'app-intro-assessment',
  templateUrl: './intro-assessment.component.html',
  styleUrl: './intro-assessment.component.css'
})
export class IntroAssessmentComponent {

}
